/* eslint-disable no-magic-numbers */
/**
 * Calculates the offset in pixels needed for a multi-select dropdown within a form.
 * This helps prevent the dropdown from being cut off at the bottom of an embedded product.
 *
 * @param {object} embeddedFormData - The data object for the embedded form,
 * expected to have a `fields` array.
 * @returns {string|null} The calculated padding-bottom offset in pixels (e.g., '360px'),
 * or `null` if no multi-select is found or an offset isn't needed (which would imply no styling).
 */
export const getMultiSelectOffset = (embeddedFormData) => {
    // Find the multi-select dropdown field
    const formMultiSelect = embeddedFormData?.fields?.find(
        (field) =>
            field.field_name === 'multi select dropdown' &&
            field?.maximum_select > 1
    );

    // If no multi-select or no valid position, return null immediately
    if (!formMultiSelect || typeof formMultiSelect.view_order === 'undefined') {
        return null;
    }

    const multiSelectPosition = formMultiSelect.view_order;
    const totalFields = embeddedFormData.fields.length;

    // Calculate the distance from the end of the form
    const formOffset = totalFields - multiSelectPosition;

    let formOffsetPixels; // No initial value, will be set in switch

    switch (formOffset) {
        // These cases imply the multi-select is very close to the end
        // A larger offset is needed to push the poll down.
        case 0: // Multi-select is the very last field
        case 1: // Multi-select is the second to last field
            formOffsetPixels = '360px';
            break;
        case 2:
            formOffsetPixels = '260px';
            break;
        case 3:
            formOffsetPixels = '200px';
            break;
        case 4:
            formOffsetPixels = '100px';
            break;
        case 5:
            formOffsetPixels = '60px';
            break;
        default:
            // For multi-selects further up, no specific offset needed, or less critical
            formOffsetPixels = null; // Return null if no specific offset is determined
            break;
    }

    return formOffsetPixels;
};
